import SentimentBreakdown from "./SentimentBreakdown";

export default SentimentBreakdown;
